export const routes = {
    home: '/home',
    login: '/',
    register: '/register',
    forgotPassword: '/forgot-password',
    // Add other routes here
};